import React from 'react'

import styled from '@emotion/styled'
import { mq, green01, text, flexiblePercent, breakP } from '../../_style'
import Bg from './../../assets/imgs/img-footer-bg.jpg'
import Br from '../atoms/br'
import Image from '../atoms/image';
import ReactPlayer from 'react-player';
import ParallaxImage from '../molecules/parallaxImage'
import BgVideo from '../../assets/imgs/video-movie.mp4'
import BgVideoSp from '../../assets/imgs/video-movie-sp.mp4'
import InViewWrapper from './inViewWrapper';

const timestamp = new Date().getTime();
const Container = styled.div`
  position: relative;
  overflow: hidden;
  &::before {
    content: "";
    display: block;
    padding-top: ${flexiblePercent.pc(444)};
    ${mq.sp} {
      padding-top: ${flexiblePercent.sp(750)};
    }
  }
`
const Inner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  ${mq.pc} {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ${mq.sp} {
    padding: 82px 0 0;
  }
  & > h3 {
    color: ${green01};
    font-weight: bold;
    ${text('30px', 70 / 30)}
    letter-spacing: 0.4em;
    ${mq.pc} {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      margin-right: ${68 / 1440 * 100}%;
    }
    ${mq.sp} {
      margin-right: -0.8em;
      ${text('21px', 76 / 42)}
      text-align: center;
    }
    span {
      display: inline-block;
      opacity: 0;
      transform: translate3d(1em, 0, 0);
      transition: opacity 0.5s ease 1s, transform 0.5s cubic-bezier(.78,.2,.61,.76) 1s;
    }
    .is-shown {
      span {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
    }
  }
`

const Video = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  pointer-events: none;
  overflow: hidden;
  ${mq.sp} {
    bottom: 0;
    height: 140%;
    margin: auto;
  }
  div {
    height: 100%;
  }
  video {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    ${mq.pc} {
      height: auto !important;
    }



    ${mq.sp} {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      object-fit: cover;
    }
  }
`
const ImgContainer = styled.div`
  display: flex;
  width: ${437 / 1440 * 100}%;
  /* margin: auto 0; */
  filter: drop-shadow(6px 6px 8px rgba(0, 0, 0, 0.1));
  ${mq.sp} {
    width: ${flexiblePercent.sp(461)};
    margin: 42px auto 0;
  }
  & > div {
    width: ${100 / 3}%;
    &:nth-of-type(2) {
      transition-delay: 0.3s
    }
    &:nth-of-type(3) {
      transition-delay: 0.5s
    }
    &:last-of-type {
      transition-delay: 0.7s
    }
    & + div {
      margin-left: 34px;
      ${mq.sp} {
        margin-left: 17.5px;
      }
    }
  }
`
export default class FooterVisual extends React.Component {
  constructor(props) {
    super(props);
    this.state = {isSp: false};
    this.resizeHandler = this.resizeHandler.bind(this);
  }
  componentDidMount() {
    this.setState({isSp: breakP >= window.innerWidth});
    window.addEventListener('resize', this.resizeHandler);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }
  resizeHandler() {
    this.setState({isSp: breakP >= window.innerWidth});
  }
  render() {
    return(
      <Container>
        <Video>
          <ParallaxImage level={this.state.isSp ? 0 : 12}>
            <ReactPlayer url={this.state.isSp ? `${BgVideoSp}?${timestamp}` : `${BgVideo}?${timestamp}`} playing={true} muted playsinline width={"100%"} height={"100%"} loop={true}></ReactPlayer>
          </ParallaxImage>
        </Video>
        <Inner>
          <h3>
            <InViewWrapper>
              <div>
                {("あらゆる人の、").split('').map((val, i) => {
                  return (<span key={i} style={{'transitionDelay': `${i * 0.05 + 0.5}s`}}>{val}</span>);
                })}
              </div>
              <div>
                {("お口の悩みのために。").split('').map((val, i) => {
                  return (<span key={i} style={{'transitionDelay': `${i * 0.05 + ("あらゆる人の、").split('').length * 0.05 + 0.5}s`}}>{val}</span>);
                })}
              </div>
            </InViewWrapper>
          </h3>
          <ImgContainer>
            <InViewWrapper isFadeIn>
              <Image filename={'img-footer-products-01.png'}></Image>
            </InViewWrapper>
            <InViewWrapper isFadeIn>
              <Image filename={'img-footer-products-03.png'}></Image>
            </InViewWrapper>
            <InViewWrapper isFadeIn>
              <Image filename={'img-footer-products-02.png'}></Image>
            </InViewWrapper>
          </ImgContainer>
        </Inner>
     </Container>
    )
  }
}
